import { Mail } from 'lucide-react'

import { SplitsAvatar } from '~/components/SplitsAvatar'
import { AddressDisplay } from '~/components/component-library'
import { AddressPopover } from '~/components/component-library/AddressDisplay/AddressPopover'
import { useContactLookup } from '~/hooks/useContacts'
import { IAddress } from '~/types'
import { EvmAddress } from '~/utils/address'
import { shortenAddress } from '~/utils/addresses'

export const RecoverySignerDisplay = ({
  address,
  name,
  email,
  hideMailIcon,
}: {
  address: string
  name?: string
  email?: string
  hideMailIcon?: boolean
}) => {
  const formattedAddress = EvmAddress.format(address)
  // Prefer the contact label so the row stays in sync with the popover
  // and with renames made from the edit dialog.
  const { data: contact } = useContactLookup(formattedAddress as IAddress)
  const displayName = contact?.orgLabel ?? name

  if (email) {
    return (
      <AddressPopover address={formattedAddress}>
        <div className="flex w-full min-w-0 items-center gap-2 text-base text-primary">
          <SplitsAvatar address={formattedAddress} size={24} />
          <span className="truncate">{displayName ?? email}</span>
          {!hideMailIcon && displayName && (
            <Mail className="size-4 shrink-0 text-secondary" />
          )}
          <span className="shrink-0 text-sm text-secondary">
            {shortenAddress(formattedAddress)}
          </span>
        </div>
      </AddressPopover>
    )
  }

  return <AddressDisplay address={formattedAddress} layout="standard" />
}
